import { Box, Typography } from "@mui/material";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";

export function CmHighIncreaseWarning({ numberOfCampaignsWithHighIncrease, threshold }) {
  if (!numberOfCampaignsWithHighIncrease) return null;

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "start",
        alignItems: "center",
        border: "1px solid #EF6C00",
        borderRadius: 1,
        padding: 2,
        gap: 2,
        mt: 2,
      }}
    >
      <WarningAmberIcon sx={{ color: "#EF6C00" }} />
      <Typography sx={{ fontWeight: "semibold", fontSize: 14, color: "#663C00" }}>
        Variación superior al <strong>{threshold}%</strong> en{" "}
        <strong>{numberOfCampaignsWithHighIncrease}</strong> campaña(s). Revisa
        los valores antes de publicar.
      </Typography>
    </Box>
  );
}
